import { SellOrderDetailsModalComponent } from './../../modals/sell-order-details-modal/sell-order-details-modal.component';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import {
  SellOrdersFilterParams,
  SellOrdersService,
  SellOrdersSortParams
} from 'src/app/core/services/sell-orders.service';
import { FinishedOutOrder } from 'src/models/OutOrder';

@Component({
  selector: 'app-sell-orders',
  templateUrl: './sell-orders.component.html',
  styleUrls: ['./sell-orders.component.scss']
})
export class SellOrdersComponent implements OnInit, OnDestroy {
  actualHour = moment().format('HH:mm');
  isModalLoading = false;
  isLoading = false;
  appliedFilters: SellOrdersFilterParams = {};
  sortParams: SellOrdersSortParams;
  dataSubscription$: Subscription;
  data: FinishedOutOrder[] = [];
  commentsSubscription$: Subscription;
  ordersMap: Map<string, FinishedOutOrder> = new Map();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    public sellOrdersService: SellOrdersService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.sellOrdersService.init();
    this.dataSubscription$ = this.sellOrdersService.items$.subscribe((data) => {
      this.ordersMap.clear();
      const newData = [...data];
      for (const d of newData) {
        this.ordersMap.set(d.id, d);
      }
      this.data = data;
      this.isLoading = false;
    });

    this.commentsSubscription$ = this.sellOrdersService.ordersCommentsQty$.subscribe(comments => {
      for (const comment of comments) {
        if (this.ordersMap.has(comment.outOrderId)) {
          this.ordersMap.get(comment.outOrderId).commentsQty = comment.commentsQty;
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.dataSubscription$?.unsubscribe();
    this.commentsSubscription$?.unsubscribe();
  }

  onFiltersApply(params: { sortParams: SellOrdersSortParams, filterParams: SellOrdersFilterParams }) {
    this.sellOrdersService.currentPage = 1;
    this.appliedFilters = params?.filterParams;
    this.sortParams = params?.sortParams;
    this.update();
  }

  async update() {
    this.isLoading = true;
    await this.sellOrdersService.reload(this.appliedFilters, this.sortParams);
    this.actualHour = moment().format('HH:mm');
    this.isLoading = false;
  }

  async getNextPage() {
    await this.sellOrdersService.getNextPage(this.appliedFilters, this.sortParams);
  }

  async getPreviousPage() {
    await this.sellOrdersService.getPreviousPage(this.appliedFilters, this.sortParams);
  }

  async onPageSizeChange(event: number) {
    await this.sellOrdersService.setPageSize(event);
  }

  async onPageChange(event: number) {
    await this.sellOrdersService.setPage(event, this.appliedFilters, this.sortParams);
  }

  onSellOrderClicked(event: { sellOrder: FinishedOutOrder, column: string }) {
    const page = event.column === 'messages' ? 3 : 0;
    this.dialog.open(SellOrderDetailsModalComponent, {
      panelClass: 'details-modal',
      autoFocus: false,
      data: { sellOrder: { ...event.sellOrder }, page }
    });
  }

  goToExpedition() {
    this.router.navigate(['/dispatch']);
  }
}
